<template>
  <iframe
    ref="iframe"
    class="text-replace-iframe"
    :src="textReplaceUrl"
    frameborder="0"
  ></iframe>
</template>

<script>
import { mapActions } from 'vuex'
import { getToken } from '@/utils/auth'

export default {
  computed: {
    textReplaceUrl() {
      return `${webConfig.api.debugger}/${this.$route.params.id}/text-replace?hideMenu=1&token=${getToken()}&t=${new Date().getTime()}`
    },
    scriptEditorOrigin() {
      return new URL(webConfig.api.debugger, window.location.origin).origin
    }
  },
  mounted() {
    window.addEventListener('message', this.handleScriptEditorMessage)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleScriptEditorMessage)
  },
  methods: {
    ...mapActions('scene', ['setScene']),
    handleScriptEditorMessage(event) {
      const iframe = this.$refs.iframe
      if (!iframe || event.source !== iframe.contentWindow) return
      if (event.origin !== this.scriptEditorOrigin) return

      const message = event.data
      if (message?.type !== 'script-editor:data-changed' || message.version !== 1) return

      const scriptId = message.payload?.scriptId
      if (typeof scriptId !== 'number') return

      this.setScene({
        sceneId: scriptId,
        isHistory: this.$route.query.isHistory === '1',
        force: true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.text-replace-iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}
</style>
